import getClassifiedsSite from 'utils/getClassifiedsSite';
import {
  AUTOCAR,
  AUTOCARUTMLINKS,
  WHATCARUTMLINKS,
  WHATCARLEASINGUTMLINKS,
  WHATCARNEWCARUTMLINKS,
  AUTOCARLEASINGUTMLINKS,
  AUTOCARNEWCARUTMLINKS,
  NEWCARSTOCKCAROUSELLINKS,
  NEWCARSTOCKSQUICKLOOKLINKS,
  NEWCARSTOCKSRESULTSLINKS,
  CARLEASINGCAROUSELLINKS,
  CARLEASINGDEALSLINKS,
  USEDCARSCAROUSELLINKS,
  USEDCARSQUICKLOOKLINKS,
  USEDCARSTOCKSRESULTSLINKS,
  AUTOCARNEWCARSTOCKCAROUSELLINKS,
  AUTOCARNEWCARSTOCKSRESULTSLINKS,
  AUTOCARNEWCARSTOCKSQUICKLOOKLINKS,
  AUTOCARCARLEASINGCAROUSELLINKS,
  AUTOCARCARLEASINGDEALSLINKS,
  AUTOCARUSEDCARSCAROUSELLINKS,
  AUTOCARUSEDCARSTOCKSRESULTSLINKS,
  AUTOCARUSEDCARSQUICKLOOKLINKS
} from './utm.links';
import { getPagePathname } from 'utils/getPagePathname';

const pagePathname = getPagePathname();

export const formatExternalLink = ({ link = '', network, gcLid }, utm) => {
  const classifiedsSite = getClassifiedsSite();
  const isAutoCar = classifiedsSite === AUTOCAR;

  // Select the appropriate UTM links based on pagePathname and isAutoCar
  let qsArr;
  if (utm !== undefined || utm !== '') {
    if (isAutoCar) {
      const importedUTM = {
        AUTOCARNEWCARSTOCKCAROUSELLINKS,
        AUTOCARNEWCARSTOCKSRESULTSLINKS,
        AUTOCARNEWCARSTOCKSQUICKLOOKLINKS,
        AUTOCARCARLEASINGCAROUSELLINKS,
        AUTOCARCARLEASINGDEALSLINKS,
        AUTOCARUSEDCARSCAROUSELLINKS,
        AUTOCARUSEDCARSTOCKSRESULTSLINKS,
        AUTOCARUSEDCARSQUICKLOOKLINKS
      };
      qsArr = importedUTM['AUTOCAR' + utm];
    } else {
      const importedUTM = {
        NEWCARSTOCKCAROUSELLINKS,
        NEWCARSTOCKSRESULTSLINKS,
        NEWCARSTOCKSQUICKLOOKLINKS,
        CARLEASINGCAROUSELLINKS,
        CARLEASINGDEALSLINKS,
        USEDCARSCAROUSELLINKS,
        USEDCARSTOCKSRESULTSLINKS,
        USEDCARSQUICKLOOKLINKS
      };
      qsArr = importedUTM[utm];
    }
  } else {
    qsArr =
      pagePathname === 'car-leasing-deals'
        ? isAutoCar
          ? AUTOCARLEASINGUTMLINKS
          : WHATCARLEASINGUTMLINKS
        : pagePathname === 'new-cars-in-stock'
        ? isAutoCar
          ? AUTOCARNEWCARUTMLINKS
          : WHATCARNEWCARUTMLINKS
        : isAutoCar
        ? AUTOCARUTMLINKS
        : WHATCARUTMLINKS;
  }

  // Add optional parameters
  if (network) qsArr.push(`network=${network}`);
  if (gcLid) qsArr.push(`gclid=${gcLid}`);

  // Return the formatted link
  return qsArr && qsArr.length > 0 ? `${link}?${qsArr.join('&')}` : link;
};



// WEBPACK FOOTER //
// ./src/utils/utmLinks/index.js